// import Definition from './Definition';

export default {
  priority: 100,
  name: app.translate('routes.home.attendance.policy.Definition'),
  path: 'definition',
  // component: Definition,
  component: load(() => import(/* webpackChunkName: "Policy-Definition" */ './Definition')),
  permissions: ['TimeAttendanceMenu/PolicyMenu/PolicyDefineMenu'],
  icon: 'content-paste',
  drawer: true,
};


